import { APP_SCORING_FORMAT } from '@/constants';
import { formatScore } from '@/domains';
import React from 'react';

export interface FormattedScoreProps {
  maxScore: number;
  score?: number;
}

export const FormattedScore: React.FC<FormattedScoreProps> = ({ maxScore, score }) => {
  if (score === undefined) return <span>-</span>;
  
  switch (APP_SCORING_FORMAT) {
    case 'percentage':
      return <span>{formatScore(score)}</span>;
    default:
      return <span>{`${score}/${maxScore}`}</span>;
  }
};

FormattedScore.displayName = 'FormattedScore';

export default FormattedScore;
